import { Component } from "@angular/core";

@Component({
    selector: 'app-doc-dialog',
    templateUrl: './doc-dialog.html'
})
export class DocDialogDialog {

}